import { Field, useFormikContext } from 'formik';
import FieldHelperText from 'src/components/util/FieldHelperText';
import MuiValidTextField from 'src/components/util/MuiValidTextField';
import Section from 'src/components/util/Section';
import Subheader from 'src/components/util/Subheader';
import { FIELDS } from 'src/data/GreenbeltInfo/constant';
import Address from '../util/Address';

export default function GreenbeltInfo() {
  const form = useFormikContext();
  const handleChange = (field) => (e) => {
    form.setFieldValue(field, e.target.value);
  };

  return (
    <Section title="Greenbelt Information">
      {FIELDS.map((field) => (
        <div key={field.name}>
          {field.name === 'info.serialNumber' && (
            <FieldHelperText>
              Enter the serial number without colons. For example, enter 999999999 instead of
              99:999:9999.
            </FieldHelperText>
          )}
          <Field
            InputLabelProps={{ shrink: true }}
            component={MuiValidTextField}
            label={field.label}
            name={field.name}
            onChange={handleChange(field.name)}
            placeholder=""
            type={field.type}
          />
        </div>
      ))}
      <Subheader>Location or Address of Subject Property</Subheader>
      <Address
        fieldNames={{
          street: 'info.address.street',
          city: 'info.address.city',
          state: 'info.address.state',
          zip: 'info.address.zip',
        }}
      />
    </Section>
  );
}
